export const links = [
    {
        label: 'O nas',
        href: '/i/o-nas'
    },
    {
        label: 'Aktualności',
        href: '/i/aktualnosci'
    },
    {
        label: 'Partnerzy',
        href: '/i/partnerzy'
    },
    {
        label: 'Kariera',
        href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy/'
    },
    {
        label: 'Mapa strony',
        href: '/i/mapa-strony'
    },
    {
        label: 'Kontakt',
        href: '/i/kontakt'
    },
    {
        label: 'Oferta reklamowa',
        href: 'https://static.opineo.pl/offer/oferta_reklamowa.pdf?v=1'
    }
] as {
    label: string;
    href: string;
}[];
